import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { Roles } from 'shared/lib/store';
import { useFeatureIsOn, FEATURES } from 'shared/lib/growthbook';
import {
  useStartBlockingTimer,
  useStartUnblockingTimer,
  useSetBlockingElementsList,
  useResetBlockingStore,
  useGetContractor,
} from 'entities/profile';
import { getClientData, isImpersonate } from 'shared/lib/api';
import { heapResetIdentity, heapSetIdentity } from 'shared/lib/heap';

// Temporary disabled in https://sirengroup.atlassian.net/browse/HB-1448
// Will be removed in one of the future task, when call center gets real phone number
export const phoneBlockIsTemporaryDisabled = true;

export function ContractorLayoutContent({ children }: { children?: ReactNode }) {
  const user = useGetContractor().data?.data;
  const startBlockTimer = useStartBlockingTimer();
  const startUnblockTimer = useStartUnblockingTimer();
  const setBlockingElementsList = useSetBlockingElementsList();
  const resetBlockingStore = useResetBlockingStore();
  const IS_TIME_BLOCKING_ON = useFeatureIsOn(FEATURES.TIME_BLOCKING);

  useEffect(() => {
    if (!isImpersonate() && getClientData().role === Roles.Contractor && user?.id && user.fullName) {
      heapSetIdentity({
        contractorId: user.id,
        contractorName: user.fullName,
      });
    } else {
      heapResetIdentity();
    }
  }, [user?.id, user?.fullName]);

  useEffect(() => {
    resetBlockingStore();
    if (IS_TIME_BLOCKING_ON && user) {
      startBlockTimer(user.timeLeftToBlocking);
      startUnblockTimer(user.timeLeftToUnblocking);
      setBlockingElementsList(user.blockedElementsList);
    }
  }, [user, IS_TIME_BLOCKING_ON]);

  return <>{children}</>;
}
